import { atom } from "jotai";
import { EPHEMERAL_NODE_TYPES } from "@zapier/canvas-constants";
import { isValidUUID } from "../utils";
import { EphemeralNodeType } from "../types";
import { nodesAtom } from "./nodesAtom";

export const isDraftModeExcludingTemplatesAtom = atom((get) => {
  const nodes = get(nodesAtom);
  return nodes.some((node) => {
    // skip nodes we never persist
    const isNotEphemeral = !EPHEMERAL_NODE_TYPES.includes(
      node.type as EphemeralNodeType,
    );
    const isNotValidUUID = !isValidUUID(node.id);
    const isNotTemplate = !node.id.startsWith("_TEMPLATE_");

    return isNotEphemeral && isNotValidUUID && isNotTemplate;
  });
});

isDraftModeExcludingTemplatesAtom.debugLabel =
  "isDraftModeExcludingTemplatesAtom";
